// frontend/src/App.js
// Componente principal de la aplicación.
// Gestiona el enrutamiento (simple, basado en estado) y la visualización de mensajes/cargas.

import React from 'react';
import { useAuthStore } from './store/authStore'; // Importa el store de autenticación
import { useUIStore } from './store/uiStore';   // Importa el store de UI
import { useAuth } from './hooks/useAuth';
import LoginPage from './pages/LoginPage';     // Página de Login
import AccessPendingPage from './pages/AccessPendingPage';
import DashboardPage from './pages/DashboardPage'; // Página del Dashboard
import LoadingSpinner from './components/LoadingSpinner'; // Componente de Spinner
import MessageBox from './components/MessageBox';     // Componente de Caja de Mensajes

function App() {
  // Suscribe al estado de autenticación
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);
  const isInitializing = useAuthStore((state) => state.isInitializing);
  const accessProvisioningRequired = useAuthStore((state) => state.accessProvisioningRequired);
  // Suscribe al estado de carga global
  const isLoading = useUIStore((state) => state.isLoading);
  const { initializeAuth } = useAuth();

  React.useEffect(() => {
    void initializeAuth();
  }, [initializeAuth]);

  return (
    <div className="relative min-h-screen bg-gray-100 font-inter">
      {/* Componente global para mostrar mensajes */}
      <MessageBox />

      {/* Spinner de carga global */}
      {(isLoading || isInitializing) && (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-40">
          <LoadingSpinner size="lg" color="text-white" />
        </div>
      )}

      {/* Renderizado condicional de páginas */}
      {isAuthenticated ? <DashboardPage /> : accessProvisioningRequired ? <AccessPendingPage /> : <LoginPage />}
    </div>
  );
}

export default App;
